<div
  flex
  layout="row"
  layout-wrap
  layout-align="space-between stretch"
  >
  <mat-card appearance="outlined" flex="100">
    <mat-card-title>
      <span [translate]="'global.client'">Client</span>
    </mat-card-title>
    <mat-card-content
      flex="100"
      layout="row"
      layout-wrap
      layout-align="space-around center"
      >
      <ng-container flex>
        <div flex="100"
          layout="row"
          layout-wrap
          layout-align="start center"
          >
          @for (info of pensionerData; track info; let i = $index) {
            <div flex="33" layout="row">
              <mat-form-field flex="100" class="right-padding-16">
                <input
                  matInput
                  readonly
                  type="text"
                  placeholder="{{ info?.PensionerNameInfo }}"
                  [value]="info?.Value"
                  />
                  <mat-label>{{ info?.PensionerNameInfo }}</mat-label>
                </mat-form-field>
              </div>
            }
          </div>
        </ng-container>
      </mat-card-content>
    </mat-card>

    <mat-card appearance="outlined" flex="100">
      <mat-card-title>
        <span [translate]="'nssi.additionsOrDebt'">Client</span>
      </mat-card-title>
      <mat-card-content
        flex="100"
        layout="row"
        layout-align="space-around center"
        >
        @if (additionOrDebtData.length > 0) {
          <div>
            @for (info of additionOrDebtData; track info; let i = $index) {
              <ng-container
                flex
                >
                <mat-form-field class="right-padding-16">
                  <input
                    matInput
                    readonly
                    type="text"
                    placeholder="{{ info?.Details }}"
                    [value]="info?.Value"
                    />
                    <mat-label>{{ info?.Details }}</mat-label>
                  </mat-form-field>
                </ng-container>
              }
            </div>
          }
          @if (additionOrDebtData.length === 0) {
            <div [translate]="'global.noData'">
              NO DATA
            </div>
          }
        </mat-card-content>
      </mat-card>

      <mat-card appearance="outlined" flex="100">
        <mat-card-title>
          <span [translate]="'nssi.pensions'">Pensions</span>
        </mat-card-title>
        <mat-card-content
          flex="100"
          layout="row"
          layout-align="space-around center"
          >
          @if (pensionsData.length > 0) {
            <div>
              @for (info of pensionsData; track info; let i = $index) {
                <ng-container
                  flex
                  >
                  @if (info?.PensionsDetails === 'Вид на пенсията:') {
                    <h3>{{info?.PensionsDetails}} {{info?.Value}}</h3>
                  }
                  @if (info?.PensionsDetails !== 'Вид на пенсията:') {
                    <mat-form-field class="right-padding-16" matTooltip="{{info?.PensionsDetails}}">
                      <input
                        matInput
                        readonly
                        type="text"
                        placeholder="{{ info?.PensionsDetails }}"
                        [value]="info?.Value"
                        />
                        <mat-label>{{ info?.PensionsDetails }}</mat-label>
                      </mat-form-field>
                    }
                  </ng-container>
                }
              </div>
            }
            @if (pensionsData.length === 0) {
              <div [translate]="'global.noData'">
                NO DATA
              </div>
            }
          </mat-card-content>
        </mat-card>
      </div>


